export const formatDateTime = (date: Date | null, time: Date | null): string => {
    if (!date || !time) return '';

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = time.getHours().toString().padStart(2, '0');
    const minutes = time.getMinutes().toString().padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:00+03:00`;
};

export const convertDateTimeFormat = (dateString: string) => {
    // Создаем объект Date из строки
    const date = new Date(dateString);
    
    // Проверяем, является ли дата очень далекой (2099 год или позже)
    const year = date.getUTCFullYear();
    if (year >= 2099) {
        return "по согласованию";
    }
    
    // Получаем UTC-время (без перевода в локальный пояс)
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');

    return `${hours}:${minutes} / ${day}.${month}.${year}`;
}